import { memo, useCallback } from "react";
import { BottomSheetView, type BottomSheetModal } from "@gorhom/bottom-sheet";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { Text } from "@src/components";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { AppBottomSheet } from "@src/features/common/components/AppBottomSheet";
import { TenantAdminConfirmContent } from "./TenantAdminConfirmContent";

interface TenantAdminBottomSheetProps {
  bottomSheetRef: React.RefObject<BottomSheetModal | null>;
  onConfirm: () => void;
}

export const TenantAdminBottomSheet = memo(({ bottomSheetRef, onConfirm }: TenantAdminBottomSheetProps) => {
  const { theme } = useUnistyles();
  const { bottom } = useSafeAreaInsets();

  const handleConfirm = useCallback(() => {
    onConfirm();
    setTimeout(() => {
      bottomSheetRef.current?.dismiss();
    }, 100);
  }, [onConfirm, bottomSheetRef]);

  return (
    <AppBottomSheet
      bottomSheetRef={bottomSheetRef}
      enableDynamicSizing
      backgroundStyle={{ backgroundColor: theme.colors.surfaceCard }}
    >
      <BottomSheetView style={[styles.container, { paddingBottom: bottom + theme.spacing["5xl"] }]}>
        <Text textStyle="md/medium" style={styles.title}>
          Organisation admin
        </Text>
        <TenantAdminConfirmContent onConfirm={handleConfirm} />
      </BottomSheetView>
    </AppBottomSheet>
  );
});

const styles = StyleSheet.create((theme) => ({
  container: {
    paddingHorizontal: theme.spacing["5xl"],
  },
  title: {
    marginBottom: theme.spacing["4xl"],
  },
}));
